import { Box, Spacer } from '@chakra-ui/react';
import About from '../Pages/About';
import Skills from '../Pages/Skills';
import Contact from '../Pages/Contact';
import Footer from './Footer';

const Home = () => {
	return (
		<Box pt='100px'>
			<About />
			<Spacer id='skills' height='150px' />
			<Skills />
			<Spacer id='contact' height='65px' />
			<Contact />
			<Footer />
		</Box>
	);
};

export default Home;